import _ from 'lodash'

import productService from '@/services/serli/product'
import qualificationService from '@/services/salesbox/qualify'
import {convertFiltersArray, convertFiltersValuesBackToMetric} from "@/common/helpers";

const environmentsStaticState = {
    context: {},
    market: "CONS",
}

const applicationState = {
    applications: [],
    application: [],
}

const environmentState = {

}

const worksiteState = {

}

const buildingAndShelvingState = {
    currentStepSurvey: null,
    fields: [],
    filters: [],
    minimumAisleWidth: '',
    maxLiftingHeight: '',
    rampLength: '',
    rampHeight: '',
    passageWidth: '',
    passageHeight: '',
    passageFirstStringer: '',
    ceilingHeight: '',
    luminaireHeight: '',
    residualCapacityMaxHeight: '',
}

const workEnvironmentState = {
    insideFloorType: null,
    outsideFloorType: null,
    floorSurfaceType: null,
    usageHoursPerDay: '',
    workstationNumber: null,
    speedLimitExist: null,
    speedLimit: null,
    workConditions: [],
    loadTimeAvailable: '',
    loadType: null,
    loadRoom: null,
    maintenanceContract: null,
    provider: null,
}

const resultsMachinesState = {
    machineResults: [],
    applicationResults: [],
    selectedMachineResults: [],
    currentStepMachineResults: 1
}

const initialState = {
    currentContext: null,
    currentStep: null,
    maxStep: null,
    steps: [],
    fields: {},
    nextStepAllowed: true,
    ...applicationState,
    ...environmentState,
    ...worksiteState,
    ...resultsMachinesState,
    ...environmentsStaticState,
};

export const state = { ...initialState };

export default {
    namespaced: true,
    state,
    mutations: {
        reset (state) {
            const s = _.cloneDeep(initialState);
            Object.keys(s).forEach(key => {
                if (key !== 'applications' && key!=='currentContext') state[key] = s[key];
            })
        },
        setCurrentContext(state, context) {
            state.currentContext = context;
        },
        setCurrentStep(state, code) {
            state.currentStep = code;
            if (!state.maxStep) state.maxStep = code
            else {
                let currentIndex = state.steps.findIndex(step => step.slug ? step.slug === code : step.code === code)
                let maxIndex = state.steps.findIndex(step => step.slug ? step.slug === state.maxStep : step.code === state.maxStep)
                if (currentIndex > maxIndex) state.maxStep = code
            }
        },
        setSteps(state, steps) {
            state.steps = steps;
        },
        setNextStepAllowed(state, value) {
            state.nextStepAllowed = value;
        },
        setContext(state, value) {
            state.context = value;
        },
        // -------------------
        // - Application Selection
        // -------------------
        setApplications(state, value) {
            state.applications = value;
        },
        setApplication(state, value) {
            state.application.push(value);
        },
        // -------------------
        // - Environment
        // -------------------
        resetWorkEnvironment(state) {
            const s = _.cloneDeep(workEnvironmentState);
            Object.keys(s).forEach(key => state[key] = s[key])
        },
        setEnvironment(state, value) {
            state.environment = value;
        },
        setInsideFloorType(state, value) {
            state.insideFloorType = value;
        },
        setOutsideFloorType(state, value) {
            state.outsideFloorType = value;
        },
        setFloorSurfaceType(state, value) {
            state.floorSurfaceType = value;
        },
        setUsageHoursPerDay(state, value) {
            state.usageHoursPerDay = value;
        },
        setWorkstationNumber(state, value) {
            state.workstationNumber = value;
        },
        setSpeedLimitExist(state, value) {
            state.speedLimitExist = value;
        },
        setSpeedLimit(state, value) {
            state.speedLimit = value;
        },
        setWorkConditions(state, value) {
            state.workConditions = value;
        },
        setLoadTimeAvailable(state, value) {
            state.loadTimeAvailable = value;
        },
        setLoadType(state, value) {
            state.loadType = value;
        },
        setLoadRoom(state, value) {
            state.loadRoom = value;
        },
        setMaintenanceContract(state, value) {
            state.maintenanceContract = value;
        },
        setProvider(state, value) {
            state.provider = value;
        },
        // -------------------
        // - Chantier
        // -------------------
        resetBuildingAndShelving(state) {
            const s = _.cloneDeep(buildingAndShelvingState);
            Object.keys(s).forEach(key => state[key] = s[key])
        },
        setDefaultStepFields(state, value) {
            Object.keys(value).forEach(index => {
                // console.log(index);
                if (value[index] && !state.fields[index]) state.fields[index] = value[index];
            })
        },
        setFields(state, payload) {
            if (payload.step && !state.fields[payload.step]) state.fields[payload.step] = {}
            if (payload.group && !state.fields[payload.step][payload.group]) state.fields[payload.step][payload.group] = {}
            if (payload.app && !state.fields[payload.step][payload.group][payload.app]) state.fields[payload.step][payload.group][payload.app] = {}

            if (payload.app) state.fields[payload.step][payload.group][payload.app] = payload.fields;
            else if (payload.group) state.fields[payload.step][payload.group] = payload.fields;
            else state.fields[payload.step] = payload.fields;
        },
        removeApplicationFields(state, payload) {
            if (state.fields['application'][payload.group][payload.app]) delete state.fields['application'][payload.group][payload.app];
        },
        setFilters(state, payload) {
            state.filters[payload.survey] = payload.value;
        },
        setMinimumAisleWidth(state, value) {
            state.minimumAisleWidth = value;
        },
        setMaxLiftingHeight(state, value) {
            state.maxLiftingHeight = value;
        },
        setRampLength(state, value) {
            state.rampLength = value;
        },
        setRampHeight(state, value) {
            state.rampHeight = value;
        },
        setPassageWidth(state, value) {
            state.passageWidth = value;
        },
        setPassageHeight(state, value) {
            state.passageHeight = value;
        },
        setPassageFirstStringer(state, value) {
            state.passageFirstStringer = value;
        },
        setCeilingHeight(state, value) {
            state.ceilingHeight = value;
        },
        setLuminaireHeight(state, value) {
            state.luminaireHeight = value;
        },
        setResidualCapacityMaxHeight(state, value) {
            state.residualCapacityMaxHeight = value;
        },
        // -------------------
        // - Solutions
        // -------------------
        resetMachineResults(state) {
            const s = _.cloneDeep(resultsMachinesState);
            Object.keys(s).forEach(key => state[key] = s[key])
        },
        setMachineResults(state, value) {
            state.machineResults = value;
        },
        setApplicationResults(state, value) {
            state.applicationResults = value;
        },
        setSelectedMachineResults(state, value) {
            state.selectedMachineResults = value;
        },
        increaseCurrentStepMachineResults(state) {
            state.currentStepMachineResults++;
        },
    },
    getters: {
        getFields: (state) => ({step, group, app}) => {
            if (!step) return undefined
            else {
                if (!group) {
                    if (!state.fields[step]) return {}
                    return state.fields[step]
                } else {
                    if (!app) {
                        if (!state.fields[step]) return {}
                        if (!state.fields[step][group]) return {}
                        return state.fields[step][group]
                    } else {
                        if (!state.fields[step]) return {}
                        if (!state.fields[step][group]) return {}
                        if (!state.fields[step][group][app]) return {}
                        return state.fields[step][group][app]
                    }
                }
            }
        },
    },
    actions: {
        async fetchMachineResults({state, rootState, commit}){
            // -------------------
            // - MARKET
            // -------------------
            let filters = [
                //{
                //    type: "select",
                //    attribute: "markets",
                //    value: "CONS",
                //},
            ];

            // filters = JSON.parse(JSON.stringify(filters));
            //filters = await convertFiltersValuesBackToMetric(filters);
            // filters = await convertFiltersArray(filters);

            let surveyFilters = new FormData();
            const excludedFields = ['width', 'height', 'length']

            Object.keys(state.fields).forEach(step => {
                switch (step) {
                    case 'application':
                        Object.keys(state.fields[step]).forEach(group => {
                            Object.keys(state.fields[step][group]).forEach(app => {
                                Object.entries(state.fields[step][group][app]).forEach(entry => {
                                    const [key, value] = entry;
                                    if (!excludedFields.includes(key) && value !== null) surveyFilters.append(`applications[${group}][${app}][${key}]`, value);
                                })
                            })
                        })
                        break;
                    case 'environment':
                        if (state.fields[step]['global'] && Object.keys(state.fields[step]['global']).length > 0) {
                            Object.entries(state.fields[step]['global']).forEach(entry => {
                                const [key, value] = entry;
                                if (!excludedFields.includes(key) && value !== null) surveyFilters.append(`filters[${state.context.id}][${key}]`, value);
                            })
                        }
                        if (state.fields[step]['ground'] && Object.keys(state.fields[step]['ground']).length > 0) {
                            Object.keys(state.fields[step]['ground']).forEach(ground => {
                                Object.entries(state.fields[step]['ground'][ground]).forEach(entry => {
                                    const [key, value] = entry;
                                    if (!excludedFields.includes(key) && value !== null) surveyFilters.append(`filters[${state.context.id}][${key}]`, value);
                                })
                            })
                        }
                        break;
                    case 'worksite':
                        Object.entries(state.fields[step]).forEach(entry => {
                            const [key, value] = entry;
                            if (!excludedFields.includes(key) && value !== null) surveyFilters.append(`filters[${state.context.id}][${key}]`, value);
                        })
                        break;
                }
            })

            filters = surveyFilters;

            /* old filters
            return qualificationService.getProducts({
                filters: filters
            }*/
            return qualificationService.getProducts(filters, {
                productType: 'machines',
                brand: rootState.settings.brand,
                category: 'qualification',
                market : state.market,
                size: 999,
                page : 1,
                locale: rootState.settings.locale.replace('_', '-'),
                unit: rootState.settings.unitType,
                context:state.context.id
            })
            .then((response) => {
                console.log(response)
                if(response.status === 200) {
                    commit('setMachineResults', response.data.machines);
                    commit('setApplicationResults', response.data.applicationGroups);
                }
            })
        },
        fetchApplications({state, rootState, commit}) {
            qualificationService.getApplications({locale: rootState.settings.locale})
                .then((response) => {
                    if(response.status === 200 && response.data) {
                        commit('setApplications', response.data.data);
                    }
                })
        },
        fetchContext({state, rootState, commit}) {
            // let response = require('@/common/utils/env.json');
            // console.log(response.datas);
            // commit('setEnvironments', response.context);
            qualificationService.get(state.market, rootState.settings.locale)
                .then((response) => {

                    if(response.data.code === 200 && response.data.contexts) {
                        commit('setContext', response.data.contexts[0]);
                    }
                })
        }
    }
};
